// Generated types for PartAllocationTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartAllocationTaskReadAPI extends TaskReadAPI {
}

export interface PartAllocationTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartAllocationTaskReadAPISchema: z.ZodType<PartAllocationTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const PartAllocationTaskWriteAPISchema: z.ZodType<PartAllocationTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
